// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PlpPatientPatientLookupPatientLookupResponse {
    static getAttributeTypeMap() {
        return PlpPatientPatientLookupPatientLookupResponse.attributeTypeMap;
    }
}
PlpPatientPatientLookupPatientLookupResponse.discriminator = undefined;
PlpPatientPatientLookupPatientLookupResponse.additionalProperties = false;
PlpPatientPatientLookupPatientLookupResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "PatientLookupResponseModel"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
];
//# sourceMappingURL=plpPatientPatientLookupPatientLookupResponse.js.map